/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable object-curly-newline */
/* eslint-disable operator-linebreak */
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useDependencyInjection } from 'hooks/useDependencyInjection';
import ContainerCard from 'components/Containers/Card/ContainerCard';
import { Box, CardContent, Grid } from '@mui/material';
import HeaderCard from 'components/Containers/Card/HeaderCard';
import api from 'services/api';
import { isValidDate } from 'utils';
import GroupButton from 'components/Buttons/ButtonGroup';
import Input from './components/Input';
import Remittance from './components/Remittance';
import Bill from 'components/Bill';

function Purchase() {
  const {
    location: { state },
    classes,
    id,
    disable,
    loadingRequest,
    success,
    error,
    history,
    requestCompleted,
  } = useDependencyInjection();

  const identificationComponentRef = useRef(null);
  const billComponentRef = useRef(null);

  const identificationRef = useRef(null);
  const billRef = useRef(null);

  const dataLocation = state?.data || state?.customData;

  // verifica se o usuário clicou em compra de insumo
  const isInput =
    state?.productType === 'input' || dataLocation?.items?.length > 0;

  const [totalPrice, setTotalPrice] = useState(0);
  const [loading, setLoading] = useState(true);

  const type = 'pagamento';

  const handleUpdateTotalPrice = (value) => {
    setTotalPrice(value);
  };

  const callbackFunctionIdentification = (payload) => {
    identificationRef.current = payload;
  };

  const callbackFunctionBill = (payload) => {
    billRef.current = payload;
  };

  const formsValid = () =>
    identificationRef.current.isValid && billRef.current.isValid;

  const getValues = (ref) => ref.current?.values;

  async function request(data) {
    try {
      loadingRequest();
      if (id) {
        await api.put(`/purchases/${id}`, data);
      } else {
        await api.post('/purchases', data);
      }
      success();
      history.push('/purchases');
    } catch (err) {
      error();
    } finally {
      requestCompleted();
    }
  }

  const info = useMemo(() => {
    if (isInput) {
      return {
        title: 'Compra de Insumos',
        renderComponent: (
          <Input
            ref={identificationComponentRef}
            updateTotalPrice={handleUpdateTotalPrice}
            callback={callbackFunctionIdentification}
          />
        ),
        description: 'Compra de insumo',
      };
    }
    return {
      title: 'Compra de Remessas',
      renderComponent: (
        <Remittance
          ref={identificationComponentRef}
          updateTotalPrice={handleUpdateTotalPrice}
          callback={callbackFunctionIdentification}
        />
      ),
      description: 'Compra de lotes',
    };
  }, [isInput]);

  // dispara submits dos componentes filhos
  const handleSubmitForms = () => {
    identificationComponentRef.current.handleSubmit();
    billComponentRef.current.handleSubmit();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleSubmitForms();

    if (formsValid()) {
      const values = isInput
        ? { ...getValues(identificationRef), lots: [] }
        : { ...getValues(identificationRef), items: [] };

      const payload = {
        ...values,
        status: id ? dataLocation.status : 'concluída',
        date: id ? isValidDate(dataLocation.date) : new Date(),
        total: id ? dataLocation.total : getValues(billRef).value,
        bill: {
          ...getValues(billRef),
          id: id ? dataLocation?.bill?.id : null,
          type,
          description: info.description,
        },
      };

      request(payload);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <ContainerCard loading={id && loading}>
      <form onSubmit={handleSubmit}>
        <Box className={classes.root}>
          <HeaderCard title={info.title} />
          <CardContent
            sx={{
              '&.MuiCardContent-root': {
                padding: 0,
              },
            }}
          >
            <Grid container direction="column" gap={3}>
              <Grid item>{info.renderComponent}</Grid>
              <Grid item>
                <Bill
                  ref={billComponentRef}
                  type={type}
                  description={info.description}
                  totalPrice={totalPrice}
                  disabledTotalValue
                  callback={callbackFunctionBill}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Box>

        <GroupButton
          deleteRoute="/purchases/"
          routeDelete="/purchases/"
          returnRoute="/purchases"
          id={id}
          disable={disable}
          messageDialogError
          disableTemporary={false} // Desativar o botão de delete
          message="Deletar essa compra pode prejudicar informações ligadas a ela. Tem certeza que deseja excluir?"
        />
      </form>
    </ContainerCard>
  );
}

export default Purchase;
